<div style="height: 100%; display: flex; flex-direction: column;">
    <div id="container" style="overflow-y: auto; flex: 1; padding: 0 2rem;">
        <div class="max-w-xl mx-auto" style="position: relative; padding: 4rem 0;">
            <div *ngFor="let message of messages; index as i; trackBy: trackByMessage"
                style="display: flex; flex-direction: column; margin-bottom: 0.25rem;">
                <!-- System Messages (Rate Limit, etc.) -->
                <div class="system-message" 
                    *ngIf="message?.role === 0 && !message?.isTyping && message?.isLimitReached == true"
                    style="align-self: center; background-color: #fff3cd; border: 1px solid #ffeaa7; color: #856404; padding: 0.75rem 1rem; border-radius: 8px; max-width: 32rem; margin: 0.5rem 0; text-align: center;">
                    {{ message.message }}
                </div>
                
                <!-- Assistant Messages -->
                <llm-response
                    *ngIf="message?.role === 0 && !message?.isTyping && !message?.isLimitReached"
                    [content]="message.uiUseTypewriter ? (message.uiRawContent ?? message.message ?? '') : (message.uiRenderedContent ?? message.uiRawContent ?? message.message ?? '')"
                    [isLoading]="false"
                    [isFinished]="true"
                    [useTypewriter]="message?.uiUseTypewriter === true"
                    [useMarkdown]="message?.uiUseTypewriter === true || !message?.uiRenderedContent"
                    [showHeader]="false"
                    [enableSmartScroll]="true"
                    [responseContainerClass]="'chat-llm-response'"
                    [responseContentClass]="'chat-llm-content'"
                    scrollContainerId="container"
                    scrollTargetId="chat-bottom"
                    (typewriterComplete)="onAssistantTypewriterComplete(i)"
                    (contentUpdate)="onAssistantContentUpdate(i, $event)">
                </llm-response>

                <!-- Typing Indicator -->
                <div style="align-self: flex-start; background-color: white; padding: 0.5rem 1rem; border-radius: 20px; box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05); max-width: 32rem;"
                    *ngIf="message?.role === 0 && message?.isTyping == true">
                    <div class="k-typing-indicator"><span></span><span></span><span></span></div>
                </div>

                <!-- User Messages -->
                <div style="align-self: flex-end; background-color: white; padding: 0.5rem 1rem; border-radius: 20px; box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05); max-width: 32rem; margin-top: 2rem"
                    *ngIf="message?.role === 1" [innerHTML]="message.message"></div>
            </div>
            <div id="chat-bottom" style="visibility: hidden; height: 1px;">&nbsp;</div>
        </div>
    </div>

    <!-- Fade overlay above footer -->
    <div class="chat-fade-overlay"></div>
    
    <div class="chat-footer">
        <div class="max-w-xl mx-auto" style="display: flex; flex-direction: column; width: 100%; gap: 0.5rem; padding-top: 0.75rem;">
            <kendo-formfield style="position: relative; width: 100%">
                <kendo-textbox placeholder="{{'aichat.ask' | translate}}" [formControl]="messageControl"
                    (keyup.enter)="sendMessage()" [maxlength]="4000" (paste)="this.textBoxService.onPaste($event, this.messageControl, 4000)"
                    style="border-radius: 9999px !important; padding-top: 0.375rem; padding-bottom: 0.375rem; padding-left: 0.5rem; padding-right: 0.5rem;">
                    <ng-template kendoTextBoxSuffixTemplate>
                        <div style="display: flex; gap: 0.5rem; align-items: center; justify-content: center;">
                            <button kendoButton class="send-button" (click)="sendMessage()"
                                [disabled]="sending || !messageControl.value?.trim()">
                                <i class="fas fa-arrow-up"></i>
                            </button>
                            <button kendoButton class="delete-button" (click)="deleteChat()"
                                [title]="'aichat.delete' | translate" [disabled]="messages.length === 0">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    </ng-template>
                </kendo-textbox>
            </kendo-formfield>
            <span translate class="ai-disclaimer">aichat.disclaimer</span>
        </div>
    </div>
</div>